import React from "react";
import Card from "../../../../components/layouts/card/card";
import { observer } from "mobx-react";
import type { WalletStore } from "../../stores/wallet/wallet-store";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import { CARD_SPACING_VARIANT } from "../../../../components/layouts/card/card.types";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import FontHeading2 from "../../../../components/fonts/font-heading2/font-heading2";
import ExternalLink from "../../../manage-returns/components/external-link/external-link";
import WalletBalance from "./wallet-balance";
import WalletStatus from "./wallet-status";
import WalletPaymentMethod from "./wallet-payment-method";
import "./wallet-card.scss";

interface Props {
    walletStore: WalletStore;
}

const WalletCard: React.FC<Props> = observer(({walletStore} :Props) => {

    return (
        <Card spacingVariant={CARD_SPACING_VARIANT.SMAll} isLoading={walletStore.isDeleting || walletStore.isLoading || walletStore.isAddingPaymentMethod || walletStore.isUpdating}>
            <div className="wallet-card">
                {!walletStore.isLoading &&
                    <>
                        <div>
                            <FontHeading2 variant={FONT_VARIANT.BOLD}>{walletStore.hasPaymentMethod ? "Wallet" : "Activate Your Wallet"}</FontHeading2>
                            <div className="wallet-card-description">
                                <FontBody2 color={FONT_COLOR.PRIMARY2}>{"Your wallet holds a pre-paid balance, from which costs for ReturnGO return labels are automatically deducted. Setting up your wallet is required to use Ship by ReturnGO."}</FontBody2>
                            </div>
                            <div>
                                <ExternalLink label={"Learn More"} url={"https://support.returngo.ai/wallet"} Font={FontBody2} />
                            </div>
                        </div>
                        <WalletBalance walletStore={walletStore} showAddCreditsButton={walletStore.hasPaymentMethod} />
                        {walletStore.hasPaymentMethod && (
                            <div className="wallet-card-status-container">
                                <WalletStatus walletStore={walletStore} />
                            </div>
                        )}
                        <div className="wallet-card-payment-method-container">
                            <FontBody2 variant={FONT_VARIANT.BOLD}>Payment method</FontBody2>
                            <WalletPaymentMethod walletStore={walletStore} />
                        </div>
                    </>
                }
            </div>
        </Card>
    )
});

export default WalletCard;
